<template>
  <div class="flex flex-col" dir="rtl">
    <div class="w-1/2 self-center px-6 mt-4 mb-2 flex gap-2" dir="rtl">
      <div
        v-for="(step, index) in provider.flow"
        :key="index"
        class="h-1 flex-1 rounded-full transition-all duration-300 ease-out"
        :class="index <= currentStepIndex ? 'bg-primary-400' : 'bg-gray-200'"
      ></div>
    </div>

    <div class="flex-1 py-4 relative overflow-hidden bg-white">
      <Transition name="fade" mode="out-in">
        <component
          :is="currentComponent"
          :provider="provider"
          :formData="flowFormData"
          @next="nextStep"
          @prev="prevStep"
          @finish="onFlowFinish"
          class="h-full"
        />
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Component, computed, reactive, ref, watch } from 'vue';
import { useAdminStore } from '@app/stores';
import { IBusinessPaymentIntegration } from '@torim-app/types';
import { Provider } from '@app/types/payments-integrations';
import { useDrawer } from '@torim-app/shared-components';

const { closeDrawer } = useDrawer();
const adminStore = useAdminStore();

const props = defineProps<{
  provider: Provider;
}>();

const currentStepIndex = ref<number>(0);
const flowFormData = reactive<IBusinessPaymentIntegration>(adminStore.getBusinessSiteData?.paymentIntegration ?? {});

const currentComponent = computed<Component | null>(() => {
  return props.provider.flow[currentStepIndex.value];
});

const nextStep = () => {
  if (currentStepIndex.value < props.provider.flow.length - 1) {
    currentStepIndex.value++;
  }
};

const prevStep = () => {
  if (currentStepIndex.value > 0) {
    currentStepIndex.value--;
  } else {
    closeDrawer();
  }
};

const onFlowFinish = () => {
  adminStore.fetchBusinessData();
  setTimeout(() => closeDrawer(), 2000);
};

watch(() => adminStore.getBusinessSiteData, () => {
  if (Object.keys(flowFormData).length > 0)
    Object.assign(flowFormData, adminStore.getBusinessSiteData.paymentIntegration);
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
